import { render } from "./NotificationSettings.vue?vue&type=template&id=07644434&bindings={\"yesNo\":\"data\",\"isLoading\":\"data\",\"emails\":\"data\",\"isValid\":\"options\",\"onSubmit\":\"options\",\"updateNotificationSettings\":\"options\",\"addNewEmail\":\"options\",\"removeEmail\":\"options\",\"prevButtonVisible\":\"options\",\"nextButtonText\":\"options\",\"stepName\":\"options\",\"validator\":\"options\"}"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"

import "./NotificationSettings.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script